import { TimeseriesChartToolbarSlotProps } from '../types/toolbar.js';

/**
 * @public
 */
export const Toolbar = (props: TimeseriesChartToolbarSlotProps) => null;

Toolbar['displayName'] = 'TimeseriesChart.Toolbar';
